import { captureException } from "@sentry/react";
import { Component, type ReactNode } from "react";
import { ErrorFC } from "./error-fc";

export class ErrorBoundary extends Component<{ children: ReactNode }> {
	state = { error: null as Error | null };

	static getDerivedStateFromError(error: Error) {
		return { error };
	}

	componentDidCatch(error: Error) {
		captureException(error);
	}

	render() {
		if (this.state.error) {
			return <ErrorFC />;
		}

		return this.props.children;
	}
}
